var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"V-Brand d-inline-flex align-items-center justify-content-center rounded-circle",style:({
    width: '40px',
    height: '40px',
    backgroundColor: 'white'
  })},[_c('img',{attrs:{"src":require("@/assets/logo.png"),"width":"36px","height":"27px","alt":"施工管理＋α"}})])}
var staticRenderFns = []

export { render, staticRenderFns }